<div class="publish-badge-icon">
  <capra-icon
    data-test="dataset-publish-icon"
    capraTooltip
    icon="icon-publish"
    [tooltipContent]="tooltipContent"
    tooltipPlacement="bottom"
    tooltipSize="regular"
  ></capra-icon>
</div>
